import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
export function createIcon(name, glyph) {
  var icon = function icon(props) {
    return React.createElement("svg", _objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: "24",
      height: "24",
      "aria-hidden": "true",
      focusable: "false"
    }, props), React.createElement("g", {
      fill: "currentColor"
    }, React.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), glyph));
  };

  icon.displayName = name;
  return icon;
}
export var CloseIcon = createIcon("Close", React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
export var PreviousIcon = createIcon("Previous", React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
export var NextIcon = createIcon("Next", React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
export var LoadingIcon = createIcon("Loading", React.createElement(React.Fragment, null, Array.from({
  length: 8
}).map(function (_, index, array) {
  return React.createElement("line", {
    key: index,
    x1: "12",
    y1: "6.5",
    x2: "12",
    y2: "1.8",
    strokeLinecap: "round",
    strokeWidth: "2.6",
    stroke: "currentColor",
    strokeOpacity: 1 / array.length * (index + 1),
    transform: "rotate(".concat(360 / array.length * index, ", 12, 12)")
  });
})));
export var ErrorIcon = createIcon("Error", React.createElement("path", {
  d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));